import { ajax } from '@/util/ajax'
const BASE_URL = '/gateway/platform-lmsapi/runtime'

const RuntimeApi = {
  fetchScriptTemplateByCompanyId (companyId, success, failure) {
    return ajax.get(
      `${BASE_URL}/script-template/list`,
      {
        companyId: companyId
      },
      success,
      failure
    )
  },
  fetchQuestionTemplateByGroupId (groupId, success, failure, isLoading) {
    return ajax.get(
      `${BASE_URL}/question-template/list`,
      {
        groupId: groupId
      },
      success,
      failure,
      { showLoading: isLoading }
    )
  },
  fetchPortfolioParameter (portfolioId, success, failure) {
    return ajax.get(
      `${BASE_URL}/portfolio-parameter/get`,
      {
        portfolioId: portfolioId
      },
      success,
      failure
    )
  },
  fetchProgramByPortfolioId (portfolioId, success, failure) {
    return ajax.get(
      `${BASE_URL}/program/list`,
      {
        portfolioId: portfolioId
      },
      success,
      failure
    )
  },
  listPortfolioByCompanyId (success, failure) {
    return ajax.get(
      `${BASE_URL}/portfolio/list`,
      null,
      success,
      failure
    )
  },
  listPortfolioParameterByCompanyId (companyId, success, failure) {
    return ajax.get(
      `${BASE_URL}/portfolio-parameter/list`,
      {
        companyId: companyId
      },
      success,
      failure
    )
  },
  sameTribePortfolio (input, success, failure) {
    return ajax.get(
        `${BASE_URL}/same-tribe-portfolio/list`,
        input,
        success,
        failure
    )
  }
}
export { RuntimeApi }
